/**
 * @description 欧洲杯-藏品售卖
*/

import Home from './home';

export default {
    Home
}